import {useAtomValue} from "jotai";
import {authenticatedUserLoadable} from "../store/authenticatedUserStore";
import {useQuery} from "@tanstack/react-query";
import {getUserNotifications} from "../services/notificationsService";
import {Notification} from "../types/domain/notification";
import {useMemo} from "react";

export function useNotifications(): Notification[] {
    const authUserState = useAtomValue(authenticatedUserLoadable);
    const user = authUserState.state === "hasData" && authUserState.data !== undefined ? authUserState.data : undefined;
    const query = useQuery({
        queryKey: ["notifications"],
        queryFn: async () => (user?.id ? await getUserNotifications({id: user.id}) : []),
        enabled: !!user?.id,
        staleTime: 1000 * 60 * 60,
    });

    return query?.data ? query.data : [];
}

export function useUnSeenNotifications(): Notification[] {
    const notifications = useNotifications();

    return useMemo(() => notifications.filter((notification) => !notification.seen), [notifications]);
}
